<template>

  <ModalContainer queryParam="msp" ref="modalContainer" size="xl">
    <b-card style="border: 1px solid #ccc;">
      <h4 class="text-center mb-2">Informacion de MSP</h4>

      <div 
        v-for="titular in itemsToMsp" 
        :key="titular.id"
      >

        <LoadFileInput
          v-model="titular.newMsp"
          :label="titular.nombre"
          :urlFile="titular.urlMsp"
        />

        <hr>
      </div>

      <div class="d-flex justify-content-end">

        <b-button 
          variant="success"
          @click="onSaveMsp"
          :disabled="disabledButtonUpdate"
        >
          Guardar Cambios
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
  
</template>

<script>
import { titularService, fileService }    from '@/shared/services';
import { LoadFileInput, ModalContainer }  from '@/shared/components';
import { terapiasService, sesionesTerapiaService }                from '../services';

export default {

  name: "LoadMsp",

  components: {
    LoadFileInput,
    ModalContainer
  },

  created() {
    this.loadData();
  },

  data() {
    return {
      itemsToMsp: [],
      dataFilesToUpdate: null,

      tokenProceso: null,

      metaData:{
        pacienteId     : null,
        nombrePaciente : null,
        proceso        : null,
        paciente       : null,
      }

    };
  },

  methods: {

    async loadData(){
      await this.loadDataProceso();
      await this.lodaDataMsp();
    },


    async loadDataProceso(){
      this.tokenProceso = this.$route.query.msp;
      if(!this.tokenProceso) return;

      const responseProceso = await sesionesTerapiaService.obtenerDataSesionTerapia(this.tokenProceso);
      console.log('response proceso terapia', responseProceso)

      if(!responseProceso) return;

      const dataPaciente = responseProceso.paciente;
      const dataProceso  = responseProceso.sesionTerapia.solicitudTerapia.terapia;

      this.metaData = {
        pacienteId     : dataPaciente.id,
        nombrePaciente : `${dataPaciente.persona.identificacion} - ${dataPaciente.persona.primerApellido} ${dataPaciente.persona.primerNombre}`,
        proceso        : `${dataProceso.codigo} - ${dataProceso.nombre}`,
        paciente       : dataPaciente
      }

    },
    
    async lodaDataMsp(){

      if(!this.metaData.pacienteId) return;
      
      const responseTitulares = await titularService.getTitularesByIdPaciente(this.metaData.pacienteId);
      const paciente = this.metaData.paciente.persona;

      const personasToMsp = responseTitulares.titulares.map( t => t.persona );
      const pacienteMsp = personasToMsp.find( t => t.identificacion === paciente.identificacion );

      if(!pacienteMsp) personasToMsp.unshift(paciente);

      const responseCita = await sesionesTerapiaService.obtenerDataSesionTerapia(this.tokenProceso);

      const urlMspMap = {
        0: responseCita.sesionTerapia.urlMspPaciente,
        1: responseCita.sesionTerapia.urlMspTitular1,
        2: responseCita.sesionTerapia.urlMspTitular2,
        3: responseCita.sesionTerapia.urlMspTitular3
      };

      this.itemsToMsp = personasToMsp.map( (t, index) => {

        return{
          identificacion: t.identificacion,
          nombre  : `${t.identificacion} - ${t.primerApellido} ${t.primerNombre}`,
          urlMsp  : urlMspMap[index],
          newMsp  : null,
          nTitular: index
        }
      });

    },



    prepararArchivosMsp(data){
      
      const mspPaciente = data.find( d => d.nTitular === 0 );
      const mspTitular1 = data.find( d => d.nTitular === 1 );
      const mspTitular2 = data.find( d => d.nTitular === 2 );
      const mspTitular3 = data.find( d => d.nTitular === 3 );

      this.dataFilesToUpdate = {
        mspPaciente: mspPaciente,
        mspTitular1: mspTitular1,
        mspTitular2: mspTitular2,
        mspTitular3: mspTitular3
      };

      this.$store.commit('setFiles', this.dataFilesToUpdate);
    },



    async onSaveMsp(){

      const response = await this.$swal({
        title: '¿Estas seguro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, guardar!',
        cancelButtonText: 'Cancelar'
      });

      if (!response.isConfirmed) return;

      let urlMspPaciente = null;
      let urlMspTitular1 = null;
      let urlMspTitular2 = null;
      let urlMspTitular3 = null;


      const { mspPaciente, mspTitular1, mspTitular2, mspTitular3 } = this.dataFilesToUpdate;

      if(mspPaciente)
        urlMspPaciente = await fileService.upload('mspSesionesTerapia', mspPaciente.newMsp, mspPaciente.identificacion, mspPaciente.urlMsp);

      if(mspTitular1)
        urlMspTitular1 = await fileService.upload('mspSesionesTerapia', mspTitular1.newMsp, mspTitular1.identificacion, mspTitular1.urlMsp);
      
      if(mspTitular2)
        urlMspTitular2 = await fileService.upload('mspSesionesTerapia', mspTitular2.newMsp, mspTitular2.identificacion, mspTitular2.urlMsp);

      if(mspTitular3)
        urlMspTitular3 = await fileService.upload('mspSesionesTerapia', mspTitular3.newMsp, mspTitular3.identificacion, mspTitular3.urlMsp);


      const fieldsToUpdate = {
        mspPaciente : urlMspPaciente,
        mspTitular1 : urlMspTitular1,
        mspTitular2 : urlMspTitular2,
        mspTitular3 : urlMspTitular3
      };
      //MODIFICAR AQUI
      const responseUpdate = await sesionesTerapiaService.updateSesionByToken(this.tokenProceso, fieldsToUpdate);

      if(!responseUpdate) {
        this.$swal({
          title: "Error al actualizar Msp",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });
        return;
      }

      await this.$swal({
        title: "Msp actualizado correctamente",
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok",
      });
      this.itemsToMsp = [];
      this.$router.go(0);
    }
  },


  computed: {

    disabledButtonUpdate(){
      return !this.itemsToMsp.find( d => d.newMsp );
    }
  },

  watch:{

    itemsToMsp: {
      deep: true,
      immediate: true,
      handler(newValue){
        this.prepararArchivosMsp(newValue);
      }
    },

    '$route.query.msp': {
      immediate:true,
      deep:true,
      handler(newValue){
        
        console.log(newValue)
        if(!newValue) return;
       
        this.loadData();
      }
    }
  }
}
</script>
